// DS: i12.9
import React from 'react';
import IconWrap, { IconSize, Props } from '../../IconWrap';

const Earnings: React.FC<React.PropsWithChildren<Props>> = props => {
  return (
    <IconWrap size={IconSize.SMALLER} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <g transform="translate(3 1)">
          <path d="M4.9 0c.495 0 .897.402.897.897v.968H6.5l.035.001a3.5 3.5 0 0 1 1.784.56c.528.346.945.836 1.177 1.418a.896.896 0 0 1-.503 1.165.9.9 0 0 1-1.169-.501 1.27 1.27 0 0 0-.492-.581 1.7 1.7 0 0 0-.853-.267H3.301c-.43 0-.826.152-1.1.395-.272.24-.4.54-.4.827s.128.586.4.826c.274.243.67.395 1.1.395H6.5c.842 0 1.67.295 2.294.846.628.555 1.007 1.333 1.007 2.17 0 .838-.379 1.616-1.007 2.171a3.47 3.47 0 0 1-2.294.846h-.703v.968a.897.897 0 0 1-1.796 0v-.968h-.7l-.035-.001a3.5 3.5 0 0 1-1.785-.56 3.06 3.06 0 0 1-1.176-1.418.896.896 0 0 1 .503-1.165.9.9 0 0 1 1.169.501c.086.216.25.422.492.58.239.156.535.253.852.268H6.5c.43 0 .825-.152 1.1-.395.272-.24.4-.54.4-.827s-.128-.586-.4-.826a1.67 1.67 0 0 0-1.1-.395H3.3c-.841 0-1.668-.295-2.293-.846C.379 6.497 0 5.719 0 4.882c0-.838.378-1.616 1.007-2.171A3.47 3.47 0 0 1 3.3 1.865H4V.897c0-.495.403-.897.898-.897"></path>
        </g>
      </svg>
    </IconWrap>
  );
};
Earnings.displayName = 'Earnings';

export default Earnings;
